import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OAuthModule, OAuthStorage } from "angular-oauth2-oidc";
import { AuthService } from "./services/auth.service";
import { AuthGuard } from "./guards/auth.guard";
import { authModuleConfig } from "./config/auth-module-config";

export function storageFactory(): OAuthStorage {
  return localStorage;
}

@NgModule({
  declarations: [],
  imports: [CommonModule, OAuthModule.forRoot(authModuleConfig)],
  providers: [
    AuthService,
    AuthGuard,
    { provide: OAuthStorage, useFactory: storageFactory },
  ],
})
export class CoreModule {}
